import uniqBy from 'lodash/uniqBy';

import type {SchedulerEventActions} from 'src/action-creators/scheduler/events';
import type {Events, ScheduledEvent} from 'src/types/scheduler/events';

import {
  SET_PAST_EVENTS,
  SET_PAST_EVENTS_FILTERS,
  APPEND_PAST_EVENTS,
  SET_UPCOMING_EVENTS,
  APPEND_UPCOMING_EVENTS,
  SET_UPCOMING_EVENTS_FILTERS,
  ADD_NEW_UPCOMING_EVENT,
  DELETE_UPCOMING_EVENT,
  UPDATE_EVENTS_STATUS,
} from 'src/action-creators/scheduler/events';

// other tools to be imported

const initialPastFilters = {
  page: '1',
  limit: '10',
  sortOrder: 'desc',
  title: '',
  distributionRules: '',
};
const initialUpcomingFilters = {
  page: '1',
  limit: '10',
  sortOrder: 'asc',
  title: '',
  distributionRules: '',
};

const initialEventData = {
  upcoming: {
    data: [],
    totalPages: 0,
    filters: initialUpcomingFilters,
  },
  past: {
    data: [],
    totalPages: 0,
    filters: initialPastFilters,
  },
};

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly upcoming: { readonly data: readonly []; readonly totalPages: 0; readonly filters: { readonly page: "1"; readonly limit: "10"; readonly sortOrder: "asc"; readonly title: ""; readonly distributionRules: ""; }; }; readonly past: { ...; }; }' is not assignable to type 'Events'.
  state: Events = initialEventData,
  action: SchedulerEventActions,
): Events => {
  switch (action.type) {
    case SET_PAST_EVENTS:
      return {
        ...state,
        past: {
          ...state.past,
          data: action.payload.data,
          totalPages: action.payload.totalPages,
        },
      };
    case APPEND_PAST_EVENTS:
      return {
        ...state,
        past: {
          ...state.past,
          data: [...state.past.data, ...action.payload.data],
          totalPages: action.payload.totalPages,
        },
      };
    case SET_PAST_EVENTS_FILTERS:
      return {
        ...state,
        past: {
          ...state.past,
          filters: action.payload,
        },
      };
    case SET_UPCOMING_EVENTS:
      return {
        ...state,
        upcoming: {
          ...state.upcoming,
          data: action.payload.data,
          totalPages: action.payload.totalPages,
        },
      };
    case APPEND_UPCOMING_EVENTS:
      return {
        ...state,
        upcoming: {
          ...state.upcoming,
          data: uniqueEvents([...state.upcoming.data, ...action.payload.data]),
          totalPages: action.payload.totalPages,
        },
      };
    case SET_UPCOMING_EVENTS_FILTERS:
      return {
        ...state,
        upcoming: {
          ...state.upcoming,
          filters: action.payload,
        },
      };
    case ADD_NEW_UPCOMING_EVENT:
      const sortedUpcomingEventsData = [
        ...state.upcoming.data,
        action.payload,
        // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
      ].sort((a, b) => new Date(a.eventStart) - new Date(b.eventStart));
      return {
        ...state,
        upcoming: {
          ...state.upcoming,
          data: uniqueEvents(sortedUpcomingEventsData),
        },
      };
    case DELETE_UPCOMING_EVENT:
      return {
        ...state,
        upcoming: {
          ...state.upcoming,
          data: state.upcoming.data.filter(
            (event) => event.id !== action.payload,
          ),
        },
      };
    case UPDATE_EVENTS_STATUS:
      return {
        ...state,
        upcoming: {
          ...state.upcoming,
          data: state.upcoming.data.map((event) => {
            const eventsObject = action.payload || {};
            if (action.payload[event.id]) {
              const {key, value} = eventsObject[event.id];
              return {...event, [key]: value};
            }
            return event;
          }),
        },
      };
    default:
      return state;
  }
};

const uniqueEvents = (events: ScheduledEvent[]): ScheduledEvent[] => {
  return uniqBy(events, 'id');
};
